import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { get } from 'lodash'

import window from 'browser-lib/window'
import { selectFeatures } from 'store/college'
import gainsight from 'common/gainsight'

export class UserTrackingStartup extends React.Component {
  static propTypes = {
    features: PropTypes.object,
    userId: PropTypes.string,
    scid: PropTypes.number,
    email: PropTypes.string,
    roles: PropTypes.array,
    isShadow: PropTypes.bool,
    name: PropTypes.string,
    children: PropTypes.node,
    collegeFeatures: PropTypes.object,
  }
  componentDidMount() {
    const { email, roles, userId, scid, isShadow, collegeFeatures } = this.props
    window.localStorage.removeItem('sessionId') // clear the session ID used by the public-facing app
    gainsight.login({
      email,
      roles,
      userId,
      isShadow,
      scid,
      collegeFeatures,
    })
  }
  componentDidUpdate(prevProps) {
    const { userId, scid, email, roles, isShadow, collegeFeatures } = this.props
    if (userId !== get(prevProps, 'userId')) {
      gainsight.login({
        email,
        roles,
        userId,
        isShadow,
        scid,
        collegeFeatures,
      })
    }
  }
  render() {
    return this.props.children
  }
}

export default connect((store) => ({
  userId: get(store.user.record, 'Id'),
  scid: get(store.user.record, 'Scid'),
  email: get(store.user.record, 'Email'),
  roles: get(store.user.record, 'Roles'),
  isShadow: get(store.user.record, 'IsShadow'),
  name: `${get(store.user.record, 'FirstName')} ${get(store.user.record, 'LastName')}`,
  features: store.features.record,
  collegeFeatures: selectFeatures(store),
}))(UserTrackingStartup)
